/**
 * Admin Application
 * Section 6.1 - Main admin panel entry point
 */

import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated, verifyAuth } from './utils/adminAuth';

// Components
import LoginForm from './components/LoginForm';
import AdminLayout from './components/AdminLayout';
import Dashboard from './components/Dashboard';

// Pages (lazy loaded)
import VehicleEditor from './pages/VehicleEditor';
import PricingEditor from './pages/PricingEditor';
import PackageManager from './pages/PackageManager';
import ErrorLogs from './pages/ErrorLogs';
import ImportExport from './pages/ImportExport';

import './AdminApp.css';

function AdminApp() {
  const [authChecked, setAuthChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    if (isAuthenticated()) {
      const valid = await verifyAuth();
      setIsLoggedIn(valid);
    } else {
      setIsLoggedIn(false);
    }
    setAuthChecked(true);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  // Show loading while checking auth
  if (!authChecked) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner" />
        <p>Loading admin panel...</p>
      </div>
    );
  }

  // Show login if not authenticated
  if (!isLoggedIn) {
    return <LoginForm onLoginSuccess={handleLoginSuccess} />;
  }

  // Show admin panel
  return (
    <Routes>
      <Route element={<AdminLayout onLogout={handleLogout} />}>
        <Route index element={<Dashboard />} />
        <Route path="vehicles" element={<VehicleEditor />} />
        <Route path="pricing" element={<PricingEditor />} />
        <Route path="packages" element={<PackageManager />} />
        <Route path="errors" element={<ErrorLogs />} />
        <Route path="import-export" element={<ImportExport />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}

export default AdminApp;
